import React from "react";
import { Link } from "react-router-dom";

const steps = [
  { n: "01", title: "Site visit", text: "We assess your roof, land, load or building in Rwanda and the region.", to: "/contact", tease: "Request a visit" },
  { n: "02", title: "Design", text: "Engineers size solar, storage, green-building or charging around your budget.", to: "/services", tease: "See what we design" },
  { n: "03", title: "Install", text: "Certified teams install and commission to RENERG quality standards.", to: "/projects", tease: "See plants we built" },
  { n: "04", title: "Support", text: "Maintenance, training and monitoring so the system keeps earning.", to: "/contact", tease: "Ask about aftercare" },
];

export default function HomeProcess() {
  return (
    <section className="py-16 lg:py-20 bg-slate-50">
      <div className="container">
        <div className="mb-10 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4">
          <div>
            <p className="renerg-kicker text-teal-700">How RENERG works</p>
            <h2 className="renerg-section mt-2 text-slate-900">From first visit to lasting power</h2>
            <p className="renerg-body mt-2 text-slate-500">Each step opens the page where that work lives — the home page only teases it.</p>
          </div>
          <Link to="/contact" className="inline-flex rounded-xl bg-teal-600 px-5 py-3 font-semibold text-white">Start a project</Link>
        </div>
        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((step) => (
            <Link key={step.n} to={step.to} className="rounded-3xl bg-white p-6 shadow-md border border-slate-100 transition hover:-translate-y-1 hover:border-teal-200 hover:shadow-lg">
              <p className="text-teal-600 font-bold">{step.n}</p>
              <h3 className="renerg-h3 mt-2 text-slate-900">{step.title}</h3>
              <p className="renerg-body mt-2 text-slate-600">{step.text}</p>
              <span className="mt-4 inline-block text-sm font-semibold text-teal-700">{step.tease} →</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
